import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, retry, tap, throwError, timer } from 'rxjs';
import { ICustomer } from './customer';
import { IAuthData } from '../seamlessauth/authData';
import { ICustomersRepInfo } from '../account/customersRepinfo';
import { APIResult } from './apiResult';
import { Buffer } from "buffer";
import { LogRocketService } from '../logrocket/logrocket.service';
import { ICustomerInfoResponse } from '../account/customerinforesponse';
import { ApiCacheService } from '../core/api-cache.service';
import { SessionService } from '../session/session.service';
@Injectable()
export class LoginService {
    private _loginUrl = 'https://webapi.securefreedom.com/Lbri/api/Authentication/Seamless/Verify/ForCustomer/';
    private _loginUrl2 = 'https://webapi.bydesign.com/Lbri/token';
    private _loginUrl3 = 'https://webapi.securefreedom.com/Lbri/token';
    private webAPIUrl = 'https://samplecart.lbri.net/api/Token';
    //private webAPIUrl = 'http://localhost/webapitest/Token';
    private custInfo = 'https://webapi.bydesign.com/Lbri/api/rep/PublicInfo/GetForCustomer/';
    private resetURL = "https://webapi.bydesign.com/Lbri/api/users/customer/sendPasswordReset?";
    private validateURL = "https://webapi.bydesign.com/Lbri/api/users/customer/validatePasswordResetKey";
    private createPassURL = "https://webapi.bydesign.com/Lbri/api/users/customer/createPassword";
    private getCustDIDURL = "https://samplecart.lbri.net/api/api/CustomerSearch?email=";
    //private getCustDIDURL = "http://localhost/webapitest/api/CustomerSearch?email=";
    public token: string = ""
    public authData!: IAuthData;
    public lbriAuthData!: IAuthData;
    public customersRepInfo!: ICustomersRepInfo;
    public lbriToken: string = "";
    public refresh_token: string = "";
    public userId: string = "";
    public lbriUserId: string = "";
    public expires: string = "";
    public lbriExpires: string = "";
    public tokenType: string = "";
    public repId: string = "";
    public apiResult!: APIResult;
    public isAuthenticated: boolean = false;
    public currentUser!: { access_token: string; refresh_token: string; };
    public custName: string = "";
    public bdtCreds: string = "postcardapi:6TfC5RdX$$";
    
    private httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };
    constructor(
        private _http: HttpClient,
        private logRocket: LogRocketService,
        private cache: ApiCacheService,
        private sessionService: SessionService
    ) {
        // var currentUser = JSON.parse(localStorage.getItem('authorizationData'));
        // this.token = currentUser && currentUser.access_token;
        // this.refresh_token = currentUser && currentUser.refresh_token;
        //this.userId = currentUser && currentUser.userName;
    }
    private headers = new HttpHeaders({
        // 'scope': 'write',
        'Content-Type': 'application/x-www-form-urlencoded'
        // '': ''
    });

    private options = {
        headers: this.headers
    };


        setCurrentUser(user: ICustomerInfoResponse, ooid) {

        this.logRocket.identifyCustomer(user, ooid);

    // if (!this.identified && user?.CustomerDID) {
    //   LogRocket.identify(user.CustomerDID, {
    //     name: user.FirstName + ' ' + user.LastName,
    //     email: user.Email?.trim() ?? user.CustomerDID + '@lbri.com',
    //     role: 'Customer',
    //     onlineOrderId: ooid
    //   });
    //   this.identified = true;
    // }
  }
    loggedIn() {
        var currentUser = JSON.parse(localStorage.getItem('authorizationData'));
        var lbriUser = JSON.parse(localStorage.getItem("lbriToken"));
        let now = new Date();

        if (currentUser !== null) {
            if (lbriUser !== null) {
                let expiredate = new Date(currentUser[".expires"]);
                let expDate2 = new Date(lbriUser[".expires"])
                //console.log(expDate2.valueOf());
                //console.log(now.valueOf());
                // if (now.valueOf() < expiredate.valueOf() || now.valueOf() < expDate2.valueOf()) {
                if (now.valueOf() < expDate2.valueOf()) {
                    ///console.log("im in");
                    return true;
                }
                else {
                    this.logOut();
                    //console.log("It thinks i am not logged in");
                    return false;
                    //return true;
                }
            }
            else {
                this.logOut();
                //console.log("It thinks i am not logged in2");
                return false;
            }

        }
        else {
            //this.logOut();
            //console.log("It thinks i am not logged in3");
            return false;
        }
    }
    refreshToken(): Observable<IAuthData> {
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

        var currentUser = JSON.parse(localStorage.getItem('authorizationData') || '{}');
        this.refresh_token = currentUser && currentUser.refresh_token;
        return this._http.post<IAuthData>(this._loginUrl2, encodeURI("grant_type=refresh_token&refresh_token=" + this.refresh_token + "&client_id=ByDesignAngularJSShoppingCart"), this.httpOptions).pipe(
            retry({
                count: MAX_RETRIES,
                delay: (error: HttpErrorResponse, retryCount: number) => {
                    // Retry only on transient failures
                    const status = error.status;

                    const isTransient =
                        status === 0 ||                 // network / CORS / DNS / offline
                        status === 429 ||               // rate limit
                        (status >= 500 && status < 600); // server errors

                    if (!isTransient) {
                        return throwError(() => error);
                    }

                    // exponential backoff with cap
                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                    return timer(backoff);
                }
            }),
            map(data => this.authData = data),
            tap(data => {
                this.token = data.access_token;

                this.refresh_token = data.refresh_token;
                this.userId = data.userName;
                this.expires = data.expires;
                localStorage.removeItem('authorizationData');
                localStorage.setItem('authorizationData', JSON.stringify(data));
                //console.log("refreshed token: " + this.token);
                this.isAuthenticated = true;
            }),
            catchError(this.handleError)
        );
    }


    getCustId(): any {
        var currentUser = JSON.parse(localStorage.getItem('authorizationData') || '{}');
        this.userId = currentUser && currentUser.userName;
        return this.userId;
    }
    // getCustName(): any{
    //     return this._http.get(this.custNameURL + this.userId.replace('-->c_', ''), this.options)
    //     .pipe(
    //         map(data=> {

    //            this.custName = data.toString().replace("\"", "");
    //            localStorage.setItem('custName', this.custName);
    //         }),
    //         catchError(this.handleError)
    //     );
    // }

    getCustomerDID(email: string | null): any {

        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

        const key = `custDID:${(email || '').toLowerCase()}`;
        return this.cache.get<any>(
            key,
            () => this._http.get(this.getCustDIDURL + email, this.options).pipe(
                retry({
                count: MAX_RETRIES,
                delay: (error: HttpErrorResponse, retryCount: number) => {
                    // Retry only on transient failures
                    const status = error.status;

                    const isTransient =
                        status === 0 ||                 // network / CORS / DNS / offline
                        status === 429 ||               // rate limit
                        (status >= 500 && status < 600); // server errors

                    if (!isTransient) {
                        return throwError(() => error);
                    }

                    // exponential backoff with cap
                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                    return timer(backoff);
                }
            }),
                map(data => {
                    localStorage.setItem('customerDID', JSON.stringify(data));
                    return data;
                }),
                catchError(this.handleError)
            ),
            10 * 60_000
        );
    }
    getCustomerInfo(): Observable<ICustomersRepInfo> {

        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

        const custId = this.userId.replace('-->c_', '');
        const key = `customerRepInfo:${custId}`;
        return this.cache.get<ICustomersRepInfo>(
            key,
            () => this._http.get<ICustomersRepInfo>(this.custInfo + custId, this.options)
                .pipe(
                    retry({
                count: MAX_RETRIES,
                delay: (error: HttpErrorResponse, retryCount: number) => {
                    // Retry only on transient failures
                    const status = error.status;

                    const isTransient =
                        status === 0 ||                 // network / CORS / DNS / offline
                        status === 429 ||               // rate limit
                        (status >= 500 && status < 600); // server errors

                    if (!isTransient) {
                        return throwError(() => error);
                    }

                    // exponential backoff with cap
                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                    return timer(backoff);
                }
            }),
                    map(data => this.customersRepInfo = data),
                    tap(data => {
                        this.repId = data.RepDID;
                        localStorage.removeItem('repId');
                        localStorage.setItem('repId', this.repId);
                    }),
                    catchError(this.handleError)
                ),
            60_000
        );
    }
    getCustomerInfoForReset(resetcustomerid: string): Observable<ICustomersRepInfo> {
        return this._http.get<ICustomersRepInfo>(this.custInfo + resetcustomerid, this.options)
            .pipe(
                map(data => this.customersRepInfo = data),
                tap(data => {
                    this.repId = data.RepDID;
                    localStorage.removeItem('repId');
                    localStorage.setItem('repId', this.repId);
                })
            );
    }
    sendResetEmail(email: string | null) {

        let auth = Buffer.from(this.bdtCreds, 'base64');

        let headers1 = new HttpHeaders({
            'content-type': 'application/x-www-form-urlencoded',
            'Authorization': "Basic " + auth.toString()
        });

        let options1 = {
            headers: headers1
        };


        return this._http.post<APIResult>(this.resetURL + "customerDID=" + email + "&langKey=en-US", options1)
            .pipe(
                map(data => this.apiResult = data),
                tap(data => {
                    if (data.isSuccessful) {
                        localStorage.removeItem('resetEmail');
                        localStorage.setItem('resetEmail', JSON.stringify(email));
                        return data;
                    }
                    return data.message;
                })
            );

    }

    //validate password reset key
    validateKey(custid: string, key: string, password: string | null) {
        let _body = {
            "customerDID": custid,
            "passwordResetKey": key,
            "newPassword": password
        };
        let auth = Buffer.from(this.bdtCreds, 'base64');
        let headers1 = new HttpHeaders({
            'content-type': 'application/json',
            'Authorization': "Basic " + auth.toString()
        });

        let options1 = {
            headers: headers1
        };

        return this._http.post<APIResult>(this.validateURL, _body, options1)
            .pipe(
                map(data => this.apiResult = data),
                tap(data => {
                    if (data.isSuccessful) {
                        return data;
                    }
                    return data.message;
                })
            );
    }

    //validate password reset key
    passReset(custid: string, key: string, password: string | null) {
        let _body = {
            "customerDID": custid,
            "passwordResetKey": key,
            "newPassword": password
        };

        let auth = Buffer.from(this.bdtCreds, 'base64');
        let headers1 = new HttpHeaders({
            'content-type': 'application/json',
            'Authorization': "Basic " + auth.toString()
        });

        let options1 = {
            headers: headers1
        };


        return this._http.post<APIResult>(this.createPassURL, _body, options1)
            .pipe(
                map(data => this.apiResult = data),
                catchError(this.handleError)
            );
    }
    seamlessLogin(guid: string) {

        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

        this.currentUser = JSON.parse(localStorage.getItem('authorizationData') || '{}');
        let headers1 = new HttpHeaders({
            'content-type': 'application/x-www-form-urlencoded',
            'Authorization': "Bearer " + this.currentUser.access_token
        });
        let options1 = {
            headers: headers1
        };
        return this._http.post<IAuthData>(this._loginUrl3, encodeURI("grant_type=seamless&guid=" + guid + "&userType=customer&client_id=ByDesignAngularJSShoppingCart"), options1)
            .pipe(
                retry({
                count: MAX_RETRIES,
                delay: (error: HttpErrorResponse, retryCount: number) => {
                    // Retry only on transient failures
                    const status = error.status;

                    const isTransient =
                        status === 0 ||                 // network / CORS / DNS / offline
                        status === 429 ||               // rate limit
                        (status >= 500 && status < 600); // server errors

                    if (!isTransient) {
                        return throwError(() => error);
                    }

                    // exponential backoff with cap
                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                    return timer(backoff);
                }
            }),
                map(data => this.authData = data),
                tap(data => {
                    if (data.access_token) {
                        this.authData = data;
                        this.token = data.access_token;
                        this.refresh_token = data.refresh_token;
                        this.userId = data.userName;
                        this.expires = data.expires;
                        localStorage.setItem('authorizationData', JSON.stringify(data));
                        //console.log("Initial token: " + this.token);
                        this.isAuthenticated = true;
                        return this.token;
                    }
                    return null;
                }),
                catchError(this.handleError)
            );
    }

    seamlessLoginVerify(guid: string) {
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...
        return this._http.get<IAuthData>(this._loginUrl + guid)
            .pipe(
                retry({
                count: MAX_RETRIES,
                delay: (error: HttpErrorResponse, retryCount: number) => {
                    // Retry only on transient failures
                    const status = error.status;

                    const isTransient =
                        status === 0 ||                 // network / CORS / DNS / offline
                        status === 429 ||               // rate limit
                        (status >= 500 && status < 600); // server errors

                    if (!isTransient) {
                        return throwError(() => error);
                    }

                    // exponential backoff with cap
                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                    return timer(backoff);
                }
            }),
                map(data => this.authData = data),
                tap(data => {
                    if (data.access_token) {
                        this.authData = data;
                        this.token = data.access_token;
                        this.refresh_token = data.refresh_token;
                        this.userId = data.userName;
                        localStorage.setItem('authorizationData', JSON.stringify(data));
                        //console.log("Initial token: " + this.token);
                        this.isAuthenticated = true;
                        return this.token;
                    }
                    return null;
                }),
                catchError(this.handleError)
            );
    }

    someLogin(un: string | null, pw: string | null) {
         const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

        return this._http.post<IAuthData>(this._loginUrl2, encodeURI("grant_type=password&username=-->c_" + un + "&password=" + pw + "&client_id=ByDesignAngularJSShoppingCart"), this.options)
            .pipe(
                retry({
                count: MAX_RETRIES,
                delay: (error: HttpErrorResponse, retryCount: number) => {
                    // Retry only on transient failures
                    const status = error.status;

                    const isTransient =
                        status === 0 ||                 // network / CORS / DNS / offline
                        status === 429 ||               // rate limit
                        (status >= 500 && status < 600); // server errors

                    if (!isTransient) {
                        return throwError(() => error);
                    }

                    // exponential backoff with cap
                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                    return timer(backoff);
                }
            }),
                map(data => this.authData = data),
                tap(data => {
                    if (data.access_token) {
                        this.authData = data;
                        this.token = data.access_token;
                        this.refresh_token = data.refresh_token;
                        this.userId = data.userName;
                        this.expires = data.expires;
                        localStorage.setItem('authorizationData', JSON.stringify(data));
                        //console.log("Initial token: " + this.token);
                        this.isAuthenticated = true;
                        return this.token;
                    }
                    return null;
                }),
                catchError(this.handleError)
            );
    }

   getLbriWebApiToken() {
        // Don’t hardcode creds in production; use env vars at minimum (still not safe in client)
        const body = new HttpParams()
            .set('grant_type', 'password')
            .set('username', 'devon@lbri.com')
            .set('password', '6TfC5RdX$$');

        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

        return this._http.post<IAuthData>(
            this.webAPIUrl,
            body.toString(),
            this.options
        ).pipe(
            retry({
                count: MAX_RETRIES,
                delay: (error: HttpErrorResponse, retryCount: number) => {
                    // Retry only on transient failures
                    const status = error.status;

                    const isTransient =
                        status === 0 ||                 // network / CORS / DNS / offline
                        status === 429 ||               // rate limit
                        (status >= 500 && status < 600); // server errors

                    if (!isTransient) {
                        return throwError(() => error);
                    }

                    // exponential backoff with cap
                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                    return timer(backoff);
                }
            }),

            map(data => (this.lbriAuthData = data)),

            tap(data => {
                if (data?.access_token) {
                    this.lbriAuthData = data;
                    this.lbriToken = data.access_token;
                    this.lbriUserId = data.userName;
                    this.lbriExpires = data.expires;

                    localStorage.setItem('lbriToken', JSON.stringify(data));
                    this.isAuthenticated = true;
                }
            }),

            catchError(this.handleError)
        );
    }


    logOut() {
        //this.logRocket.setRuntimeEnabled(false);
        localStorage.removeItem('authorizationData');
        localStorage.removeItem('prodCount');
        localStorage.removeItem('shippingData');
        localStorage.removeItem('cartItems');
        localStorage.removeItem('custName');
        localStorage.removeItem('lbriToken');
        localStorage.removeItem('guid');
        localStorage.removeItem('validatedAddress');
        localStorage.removeItem('createAccountFields');
        localStorage.removeItem('allCustInfo');
        localStorage.removeItem('merchantInfoTemp');
        localStorage.removeItem('nuveiSessionToken');
        localStorage.removeItem('orderId');
        localStorage.removeItem('orderInfo');
        localStorage.removeItem('custPhone');
        localStorage.removeItem('customerInfo');
        localStorage.removeItem('emailAddress');
        localStorage.removeItem('originalAddress');
        localStorage.removeItem('validatedAddress');
        localStorage.removeItem('personalMessage');
        localStorage.removeItem('repFullInfo');
        localStorage.removeItem('repInfo');
        localStorage.removeItem('shipMethod');
        localStorage.removeItem('cameFromCreateAccount')
        localStorage.removeItem('completedOrder');
        sessionStorage.removeItem('lbri-tab-session-id');
        

        
        this.cache.clear();
        this.sessionService.logout();
        this.custName = "";

        this.isAuthenticated = false;
        this.token = "";
        this.refresh_token = "";
        this.userId = "";


    }
    // seamlessLogin(): Observable<ICustomer> {
    //     return this._http.get(this._loginUrl)
    //         .map((response: Response) => response.json())
    //         .do(data => console.log('All: ' +  JSON.stringify(data)))
    //         .catch(this.handleError);
    // }

    // getProduct(id: number): Observable<IProduct> {
    //     return this.getProducts()
    //         .map((products: IProduct[]) => products.find(p => p.productId === id));
    // }

    handleError(error: HttpErrorResponse) {
        let errorMessage = 'Unknown error!';
        if (error.error instanceof ErrorEvent) {
            // Client-side errors
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // Server-side errors
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        //window.alert(errorMessage);
        return throwError(() => new Error(errorMessage));
    }
}
